import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';
import { doc, getDoc } from 'firebase/firestore';
import { ConferenceFirestoreResponse } from 'src/types';

import { db } from '../config'; // Adjust the path as needed

export const useGetConferenceFromFirestore = (
  hotelId: string,
  documentId: string,
  options?: UseQueryOptions<ConferenceFirestoreResponse, FirebaseError>,
  // eslint-disable-next-line max-len
): UseQueryResult<ConferenceFirestoreResponse, FirebaseError> => useQuery<ConferenceFirestoreResponse, FirebaseError>({
  queryKey: [`hotels/${hotelId}/conferences/${documentId}`] as const,
  queryFn: async () => {
    if (!documentId) {
      throw new FirebaseError('invalid-argument', 'No document ID provided');
    }

    const businessCardDocRef = doc(db, `hotels/${hotelId}/conferences`, documentId);
    const snapshot = await getDoc(businessCardDocRef);

    if (!snapshot.exists()) {
      throw new FirebaseError('not-found', `Document with ID "${documentId}" does not exist.`);
    }

    return {
      id: snapshot.id,
      ...snapshot.data(),
    } as ConferenceFirestoreResponse;
  },
  retry: 0,
  ...options,
});
